import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React__default__default from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../../node_modules/@flixbus/honeycomb/dist/scss/components/header-brand.scss.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import { HEADER_BRAND_APPEARANCES } from './types.js';
import themeConfig from '../../../themes.conf.js';
import { Injecss } from '../../../packages/injecss/injecss.js';

var bemBrand = HoneyBem.init('header-brand', styles);
var HeaderBrand = function (_a) {
  var alt = _a.alt,
    appearance = _a.appearance,
    extraClasses = _a.extraClasses,
    height = _a.height,
    href = _a.href,
    RouterLink = _a.RouterLink,
    src = _a.src,
    width = _a.width,
    _b = _a.theme,
    theme = _b === void 0 ? 'default' : _b,
    rest = __rest(_a, ["alt", "appearance", "extraClasses", "height", "href", "RouterLink", "src", "width", "theme"]);
  var themedSrc = Array.isArray(src) ? src.filter(function (item) {
    return item.theme === theme;
  })[0].src : src;
  var themedAppearance = Array.isArray(src) && src.filter(function (item) {
    return item.theme === theme;
  })[0].appearance || appearance;
  var image = /*#__PURE__*/React__default__default.createElement("img", {
    className: bemBrand.e('img'),
    src: themedSrc,
    alt: alt,
    width: width,
    height: height
  });
  return /*#__PURE__*/React__default__default.createElement("div", {
    className: bemBrand.b([themedAppearance], extraClasses)
  }, RouterLink ? /*#__PURE__*/React__default__default.createElement(RouterLink, __assign({
    className: bemBrand.e('link'),
    to: href
  }, rest), image) : /*#__PURE__*/React__default__default.createElement("a", __assign({
    className: bemBrand.e('link'),
    href: href
  }, rest), image));
};
HeaderBrand.displayName = 'HeaderBrand';
HeaderBrand.propTypes = {
  alt: PropTypes__default.string.isRequired,
  href: PropTypes__default.string.isRequired,
  src: PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.arrayOf(PropTypes__default.shape({
    theme: PropTypes__default.string.isRequired,
    src: PropTypes__default.string.isRequired,
    appearance: PropTypes__default.oneOf(HEADER_BRAND_APPEARANCES)
  }))]).isRequired,
  appearance: PropTypes__default.oneOf(HEADER_BRAND_APPEARANCES),
  extraClasses: PropTypes__default.string,
  height: PropTypes__default.string,
  RouterLink: PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.object]),
  theme: PropTypes__default.oneOf(themeConfig.honeycombThemes),
  width: PropTypes__default.string
};
var headerBrand = Injecss(HeaderBrand, styles);

export { HeaderBrand, headerBrand as default };
